import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconMedicalCrossCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconMedicalCrossCircle"><Circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><Path fillRule="evenodd" clipRule="evenodd" d="M13.5 10.5V7.75H10.5V10.5H7.75V13.5H10.5V16.25H13.5V13.5H16.25V10.5H13.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconMedicalCrossCircle;
